import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "font-bold text-black" }, "MIRA", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, _hoisted_3))
}